import Login from "../views/Login";
import Register from "../views/Register";
import ForgotPassword from "../views/ForgotPassword";
import Challenge from "../views/Challenge";
import Challenges from "../views/Challenges";
import Settings from "../components/Settings";
import ResetPassword from "../components/ResetPassword";
import Lesson from "../views/Lesson";
import LessonCompleted from "../views/LessonCompleted";
import Disciplines from "../views/Disciplines";
import PageNotFound from "../components/PageNotFound";
import UserProfile from "../components/UserProfile";
import AdminLesson from "../views/AdminLesson";

export default [
  // {
  //   path: "/about",
  //   name: "About",
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue")
  // },
  {
    path: "/",
    component: Challenge,
    name: "Desafio",
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/admin/lesson/:lessonId",
    component: AdminLesson,
    name: "AdminLesson",
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    }
  },

  {
    path: "/desafio",
    component: Challenge,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/desafio/:challengeId",
    component: Challenge,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/desafio/aula/:number",
    component: Lesson,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/desafio/:challengeId/aula/:number",
    component: Lesson,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/desafio/aula/:number/completed",
    component: LessonCompleted,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/desafio/:challengeId/aula/:number/completed",
    component: LessonCompleted,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: "/desafios",
    component: Challenges,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/ajustes",
    component: Settings,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/ajustes/perfil",
    component: UserProfile,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/ajustes/disciplinas",
    component: Disciplines,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: "/register",
    component: Register,
    name: "register",
    meta: {
      requiresGuest: true
    }
  },
  {
    path: "/login",
    component: Login,
    name: "login",
    meta: {
      requiresGuest: true
    }
  },
  {
    path: "/forgot",
    component: ForgotPassword,
    meta: {
      requiresGuest: true
    }
  },
  {
    path: "/password/reset",
    component: ResetPassword,
    meta: {
      requiresGuest: true
    }
  },
  { path: "*", component: PageNotFound }
];
